@if (this.documentTypeListItem$ | async; as documentTypes) {
  <form [formGroup]="this.form">
    <table
      class="table table-striped table-hover"
      formArrayName="documentTypes"
    >
      <thead>
      <tr>
        <th style="width: 90px">
          <a translate>PRODUCT_CATEGORY_LBL_CLAIM_TYPE_DOC_REQUIRED</a>
        </th>
        <th>
          <a translate>PRODUCT_CATEGORY_LBL_DOCUMENTTYPE</a>
        </th>
        <th style="width: 110px">
          <a translate>PRODUCT_CATEGORY_LBL_MANDATORY</a>
        </th>
      </tr>
      </thead>
      <tbody>
        @for (documentType of documentTypes; track documentType; let i = $index) {
          <tr [formGroupName]="i" [class.table-primary]="isChecked(i)">
            <td class="align-middle" (click)="checkDocumentType(documentType.id)">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [formControlName]="'checked'"
                />
              </div>
            </td>
            <td (click)="checkDocumentType(documentType.id)">
              {{documentType.name }}
            </td>
            <td class="text-center" (click)="updateMandatoryValue(documentType.id)">
              <input
                type="checkbox"
                [formControlName]="'mandatory'"
              />
            </td>
          </tr>
        }
      </tbody>
    </table>
  </form>
}
